'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var TimeoutError = /*#__PURE__*/function (_Error) {
  _inherits(TimeoutError, _Error);

  var _super = _createSuper(TimeoutError);

  function TimeoutError() {
    var _this;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'request timed out';

    _classCallCheck(this, TimeoutError);

    _this = _super.call(this, message);
    _this.name = 'TimeoutError';
    _this.code = TimeoutError.code;
    return _this;
  }

  return TimeoutError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

TimeoutError.code = 'ERR_TIMEOUT';
exports.TimeoutError = TimeoutError;